(function () {
  document.querySelectorAll(".checkbox__option input").forEach((item) => {
    item.addEventListener("click", (e) => {
      var form = item.closest("form"),
        data = new FormData(form),
        fieldset = item.closest("fieldset");

      fieldset.setAttribute("disabled", "disabled");

      $.ajax({
        url: form.getAttribute("action"),
        type: "POST",
        data,
        processData: false,
        contentType: false,
      })
        .done(() => {})
        .fail(() => (item.checked = !item.checked))
        .always(() => fieldset.removeAttribute("disabled"));
    });
  });
})();
